import { z } from "zod";

import { i18n } from "@lib/i18n";
import { globalLayoutRoute } from "@routes";
import { allowAdminAndUser, redirectToAccessFallback, requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const contractsSearchSchema = z
    .object({
        search: z.string().default("").optional(),
    })
    .partial();
type ContractsSearch = z.infer<typeof contractsSearchSchema>;

export const contractsRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `contracts`,
    component: lazyRouteComponent(() => import("./components/Contracts")),
    validateSearch: (search: ContractsSearch) => contractsSearchSchema.parse(search),
    beforeLoad: async () => {
        const allowedAdminAndUser = await allowAdminAndUser();
        if (!allowedAdminAndUser) {
            redirectToAccessFallback();
        }
        requireScope("accountOrNetwork");

        return { getTitle: () => i18n.doc_title_contracts() };
    },
});
const contractsIndexSearchSchema = z
    .object({
        page: z.number().default(1).optional(),
    })
    .partial();
type ContractsIndexSearch = z.infer<typeof contractsIndexSearchSchema>;

export const contractsIndexRoute = createRoute({
    getParentRoute: () => contractsRoute,
    path: `/`,
    validateSearch: (search: ContractsIndexSearch) => contractsIndexSearchSchema.parse(search),
    component: lazyRouteComponent(() => import("./components/ContractsBatches")),
});
const contractsBatchesArchivesSearchSchema = z
    .object({
        page: z.number().catch(1),
    })
    .partial();
type ContractsBatchesArchivesSearch = z.infer<typeof contractsBatchesArchivesSearchSchema>;
export const contractsBatchesArchivesRoute = createRoute({
    getParentRoute: () => contractsRoute,
    path: `archives`,
    validateSearch: (search: ContractsBatchesArchivesSearch) =>
        contractsBatchesArchivesSearchSchema.parse(search),
    component: lazyRouteComponent(() => import("./components/ContractsBatchesArchives")),
});
export const contractsSignatureRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `contracts/$id/signature`,
    component: lazyRouteComponent(() => import("./components/ContractsSignature")),
    beforeLoad: async () => {
        const allowedAdminAndUser = await allowAdminAndUser();
        if (!allowedAdminAndUser) {
            redirectToAccessFallback();
        }
        requireScope("accountOrNetwork");
    },
});
